var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
(function () {
    angular.module('QMC.ClientInformation', []).config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('clientInformation', {
            url: '/clientInformation',
            templateUrl: qmcBase + '/ClientInformation',
            controller: 'ClientInformationController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: ClientInformation');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var ClientInformation;
    (function (ClientInformation) {
        var HttpProvider = /** @class */ (function () {
            function HttpProvider() {
            }
            HttpProvider.configureHttpProvider = function ($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            };
            return HttpProvider;
        }());
        ClientInformation.HttpProvider = HttpProvider;
    })(ClientInformation = QMC.ClientInformation || (QMC.ClientInformation = {}));
})(QMC || (QMC = {}));
(function () {
    angular.module('QMC.ClientInformation')
        .config(['$httpProvider', QMC.ClientInformation.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var ClientInformation;
    (function (ClientInformation) {
        var ClientInformationService = /** @class */ (function (_super) {
            __extends(ClientInformationService, _super);
            function ClientInformationService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.modulePath = '/ClientInformation';
                return _this;
            }
            ClientInformationService.prototype.getClientInformationWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/WvModel', {}, function (data) {
                    return data;
                });
            };
            ClientInformationService.prototype.getCategoryList = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/CategoryList', {}, function (data) {
                    return data;
                });
            };
            ClientInformationService.prototype.getClientInformation = function (form, formatText) {
                if (formatText === void 0) { formatText = false; }
                return _super.prototype.post.call(this, this.modulePath + ("?formatText=" + formatText), form).then(function (data) {
                    return data;
                });
            };
            ClientInformationService = __decorate([
                QMC.Service('QMC.ClientInformation', 'ClientInformationService'),
                QMC.Inject('$http', '$q')
            ], ClientInformationService);
            return ClientInformationService;
        }(QMC.Common.BaseService));
        ClientInformation.ClientInformationService = ClientInformationService;
    })(ClientInformation = QMC.ClientInformation || (QMC.ClientInformation = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var ClientInformation;
    (function (ClientInformation) {
        var QmClientInformationDirective = /** @class */ (function () {
            function QmClientInformationDirective($qui, lng, permissionService, clientInformationService, clientService, employeeService) {
                var _this = this;
                this.$qui = $qui;
                this.lng = lng;
                this.permissionService = permissionService;
                this.clientInformationService = clientInformationService;
                this.clientService = clientService;
                this.employeeService = employeeService;
                this.restrict = 'E';
                this.templateUrl = './clientinformation/ClientInformationDirective';
                this.replace = true;
                this.scope = {
                    qmSelectedClients: '=',
                };
                this.groupTags = {
                    client: this.lng.translate(0, 'Klient'),
                    flsGroup: this.lng.translate(0, 'Fachleistungsgruppe'),
                    personslist: this.lng.translate(0, 'Personenliste')
                };
                this.link = function (scope) {
                    var storageName = 'ClientInfo_' + $('#session').data().userId;
                    scope.form = {
                        clients: scope.qmSelectedClients,
                        employee: scope.qmSelectedEmployee,
                        includeEmployeesThatModified: true,
                        markings: [],
                        livingAreas: [],
                        dateFrom: new Date().setMonth(new Date().getMonth() - 1),
                        dateTo: new Date(),
                        categoryPreselection: "a6ce4251-f69e-4f03-b7c0-00d80e53aeaf",
                        searchwords: "",
                        privateContent: false,
                        allCategories: true,
                        allLivingAreas: true
                    };
                    scope.clientInfo = {
                        clientInformation: [],
                        clientInfoText: "",
                        orderAsc: false
                    };
                    var cacheFilter = function () {
                        var temp = angular.copy(scope.form);
                        delete temp.clients;
                        delete temp.employee;
                        delete temp.dateFrom;
                        delete temp.dateTo;
                        temp.orderAsc = scope.clientInfo.orderAsc;
                    };
                    scope.$watch('qmSelectedEmployee', function (newVal, oldVal) {
                        if (newVal === oldVal)
                            return;
                        scope.form.clients = scope.qmSelectedEmployee;
                    });
                    scope.$watch('qmSelectedClients', function (newVal, oldVal) {
                        if (newVal === oldVal)
                            return;
                        scope.form.clients = scope.qmSelectedClients;
                    });
                    scope.$watch('form.clients', function (newVal, oldVal) {
                        if (newVal === oldVal)
                            return;
                        scope.qmSelectedClients = scope.form.clients;
                    });
                    _this.permissionService.getPermissionsByObjectType(143000).then(function (data) {
                        scope.allowExport = data[0].print;
                    });
                    scope.init = function () {
                        var restoreStorage = false;
                        scope.$watch('clientInfo.orderAsc', function (newVal, oldVal) {
                            if (newVal === oldVal)
                                return;
                            cacheFilter();
                            scope.clientInfo.clientInfoText = _this.createTextFromClientInfo(scope.clientInfo.clientInformation, scope.clientInfo.orderAsc);
                        });
                        scope.$watch('form.categoryPreselection', function (newVal, oldVal) {
                            if (restoreStorage)
                                return;
                            if (newVal !== oldVal || !scope.form || !scope.form.categoryPreselection)
                                // find selected preselection
                                for (var _i = 0, _a = scope.categoryPreselectionList; _i < _a.length; _i++) {
                                    var category = _a[_i];
                                    if (category.id === scope.form.categoryPreselection) {
                                        scope.form.categories = category.category;
                                        scope.form.livingAreas = category.livingArea.filter(function (x) { return x != null; });
                                        break;
                                    }
                                }
                            //if no livingAreas where found for the selected category, fill the livingAreas with the formattedLivingAreas
                            if (scope.form.livingAreas.length === 0) {
                                scope.form.livingAreas = scope.formattedLivingAreas.map(function (a) { return a.value; });
                            }
                        });
                        if (localStorage.getItem(storageName)) {
                            restoreStorage = true;
                            var storage = JSON.parse(localStorage.getItem(storageName));
                            scope.clientInfo.orderAsc = storage.orderAsc;
                            scope.form = __assign(__assign({}, scope.form), storage);
                            setTimeout(function () { restoreStorage = false; }, 50);
                        }
                        scope.$watch('form', function () {
                            cacheFilter();
                        }, true);
                    };
                    scope.getData = function () {
                        scope.loadingData = true;
                        _this.clientInformationService.getCategoryList().then(function (dataCategoryList) {
                            scope.categoryPreselectionList = dataCategoryList;
                            scope.formattedCategoryPreselections = dataCategoryList.map(function (x) { return ({ value: x.id, text: x.name }); });
                            _this.clientInformationService.getClientInformationWv().then(function (dataWv) {
                                scope.loadingData = false;
                                dataWv.livingAreaWvList.unshift({
                                    id: QMC.Common.Constants.GUID_EMPTY,
                                    objectId: QMC.Common.Constants.GUID_EMPTY,
                                    name: _this.lng.translate(20026009, "Ohne Lebensbereich"),
                                    isFix: true,
                                    value: 0
                                });
                                scope.formattedCategories = dataWv.categoryWvList.map(function (x) { return ({ value: x.objectId, text: x.name }); });
                                scope.formattedLivingAreas = dataWv.livingAreaWvList.map(function (x) { return ({ value: x.objectId, text: x.name }); });
                                scope.formattedMarkings = dataWv.markingWvList.map(function (x) { return ({ value: x.objectId, text: x.name }); });
                                _this.clientInformationService.getCategoryList().then(function (dataCategoryList) {
                                    scope.categoryList = dataCategoryList;
                                    for (var _i = 0, _a = scope.categoryList; _i < _a.length; _i++) {
                                        var category = _a[_i];
                                        if (category.category.length === 0)
                                            category.category = scope.formattedCategories.map(function (a) { return a.value; });
                                        if (category.livingArea.length === 0)
                                            category.livingArea = scope.formattedLivingAreas.map(function (a) { return a.value; });
                                    }
                                    scope.init();
                                });
                            });
                        });
                    };
                    scope.getReferences = function () {
                        scope.formattedReferences = [];
                        scope.loadingClients = true;
                        _this.clientService.getClientPersonList().then(function (data) {
                            scope.formattedReferences = scope.formattedReferences.concat(data.map(function (x) { return ({ value: x.objectId, text: _this.$qui.createPersonDisplay(x.lastName, x.firstName, x.shortCaption, x.personNumber) + (", " + x.institute), group: _this.groupTags.client }); }));
                            scope.loadingClients = false;
                        });
                        _this.clientService.getFlsGroupList(0, -1).then(function (data) {
                            scope.formattedReferences = scope.formattedReferences.concat(data.items.map(function (x) { return ({ value: x.objectId, text: x.name + (", " + x.institution), group: _this.groupTags.flsGroup }); }));
                        });
                        _this.clientService.getAllPersonLists().then(function (data) {
                            scope.formattedReferences = scope.formattedReferences.concat(data.map(function (x) { return ({ value: x.objectId, text: x.name, group: _this.groupTags.personslist }); }));
                        });
                    };
                    scope.getEmployee = function () {
                        scope.loadingEmployee = true;
                        _this.employeeService.getEmployeeList().then(function (data) {
                            scope.formattedEmployee = data.map(function (x) { return ({ value: x.objectId, text: _this.$qui.createPersonDisplay(x.name, x.forename, x.shortCaption, x.employeeNr), group: x.institute }); });
                            scope.loadingEmployee = false;
                        });
                    };
                    scope.getData();
                    scope.getReferences();
                    scope.getEmployee();
                    scope.print = function () {
                        var winPrint = window.open('', '', 'left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0');
                        winPrint.document.write(scope.clientInfo.clientInfoText);
                        winPrint.document.close();
                        winPrint.focus();
                        winPrint.print();
                        winPrint.close();
                    };
                    scope.createClientInfo = function () {
                        var _a, _b;
                        scope.clientInfo.clientInformation = [];
                        scope.clientInfo.clientInfoText = '';
                        if (scope.form.clients.length === 0) {
                            _this.$qui.notify({
                                message: _this.lng.translate(20026007, "Kein Klient angegeben"),
                                title: _this.lng.translate(20002017, "Warnung"),
                                timer: 5000
                            });
                            return;
                        }
                        scope.form.dateFrom = _this.$qui.createDateFromString(scope.form.dateFrom);
                        scope.form.dateTo = _this.$qui.createDateFromString(scope.form.dateTo);
                        scope.loadingInfo = true;
                        var getForm = {
                            references: _this.createReferences((_a = scope.form.clients) !== null && _a !== void 0 ? _a : [], (_b = scope.form.employee) !== null && _b !== void 0 ? _b : [], scope.formattedReferences),
                            //ReferenceClientIds: scope.form.clients,
                            //ReferenceEmployeeIds: scope.form.employee,
                            includeEmployeesThatModified: scope.form.includeEmployeesThatModified,
                            categoryIds: scope.form.categories,
                            livingAreaIds: scope.form.livingAreas,
                            markingIds: scope.form.markings,
                            searchterms: scope.form.searchwords.split(";"),
                            dateFrom: scope.form.dateFrom,
                            dateTo: scope.form.dateTo,
                            privateContent: scope.form.privateContent
                        };
                        _this.clientInformationService.getClientInformation(getForm, scope.form.formatText).then(function (data) {
                            scope.clientInfo.clientInformation = data.sort(function (a, b) { return a.reference.localeCompare(b.reference); });
                            scope.clientInfo.clientInfoText = _this.createTextFromClientInfo(scope.clientInfo.clientInformation, scope.clientInfo.orderAsc);
                            scope.loadingInfo = false;
                        });
                    };
                };
            }
            QmClientInformationDirective.prototype.createTextFromClientInfo = function (clientInfo, orderAsc) {
                var result = "";
                // items are arrangend for client so we create text for client
                for (var i = 0; i < clientInfo.length; i++) {
                    var client = clientInfo[i];
                    if (i !== 0)
                        result += "<hr /><hr />";
                    // create Header
                    result += this.createBoldText(this.lng.translate(20026008, "Klienteninformation") + ": " + client.reference + " " + this.lng.translate(20000218, "vom") + " " + new Date().toLocaleDateString());
                    result += "<br>";
                    //Order list by datefrom according to setting
                    client.items = this.orderByDate(client.items, orderAsc);
                    for (var _i = 0, _a = client.items; _i < _a.length; _i++) {
                        var item = _a[_i];
                        result += "<hr /><p>";
                        result += this.createBoldText(item.category + " " + client.reference + ', ' + item.title + "<br />");
                        if (item.dateFrom)
                            result += moment(item.dateFrom).format("DD.MM.YYYY HH:mm") + " ";
                        if (item.dateTo)
                            result += "- " + moment(item.dateTo).format("DD.MM.YYYY HH:mm") + " ";
                        if (item.author && item.author.length > 0)
                            result += this.lng.translate(20000062, "Autor") + ": " + item.author;
                        for (var k = 0; k < item.content.length; k++) {
                            var content = item.content[k];
                            result += "<br />";
                            var header = item.content[k].title && item.content[k].title.length > 0 ? this.createBoldText(item.content[k].title) + ' ' : '';
                            if (content.date && k > 0)
                                header += moment(content.date).format("DD.MM.YYYY HH:mm");
                            if (content.author && content.author.trim() !== "" && k > 0)
                                header += " " + this.lng.translate(20000062, "Autor") + ": " + content.author + " ";
                            if (content.livingArea && content.livingArea.trim() !== "")
                                header += this.createBoldText(this.lng.translate(20000074, "Lebensbereich") + ": " + content.livingArea);
                            result += header.trim().length > 0 ? header.trim() + '<br />' : '';
                            result += content.comment.length > 0 ? content.comment + "<br />" : "";
                        }
                        result += "</p>";
                    }
                    result += "<br />";
                }
                return result;
            };
            QmClientInformationDirective.prototype.orderByDate = function (items, ascending) {
                var _this = this;
                return items.sort(function (a, b) {
                    var aDateFrom = a.dateFrom ? _this.$qui.createDateFromString(a.dateFrom) : undefined;
                    var bDateFrom = b.dateFrom ? _this.$qui.createDateFromString(b.dateFrom) : undefined;
                    if ((!aDateFrom && bDateFrom) || (aDateFrom < bDateFrom))
                        return ascending ? -1 : 1;
                    if ((aDateFrom && !bDateFrom) || (aDateFrom > bDateFrom))
                        return ascending ? 1 : -1;
                    return 0;
                });
            };
            QmClientInformationDirective.prototype.createBoldText = function (text) {
                return "<strong>" + text + "</strong>";
            };
            QmClientInformationDirective.prototype.createReferences = function (selectedReferences, selectedEmployees, references) {
                var _this = this;
                return __spreadArrays(selectedReferences.map(function (x) {
                    var _a;
                    return ({
                        id: x,
                        type: _this.getReferenceTypeByGroupName((_a = references.filter(function (y) { return y.value === x; })[0]) === null || _a === void 0 ? void 0 : _a.group)
                    });
                }), selectedEmployees.map(function (x) { return ({ id: x, type: 120000 }); }));
            };
            QmClientInformationDirective.prototype.getReferenceTypeByGroupName = function (group) {
                switch (group) {
                    case this.groupTags.flsGroup:
                        return 710000;
                    case this.groupTags.personslist:
                        return 190000;
                    default:
                        return 140000;
                }
            };
            QmClientInformationDirective = __decorate([
                QMC.Directive('QMC.ClientInformation', 'qmClientInformation', ['$qui', 'QmcLanguageService', 'QmcPermissionService', 'ClientInformationService', 'KlientService', 'EmployeeService'])
            ], QmClientInformationDirective);
            return QmClientInformationDirective;
        }());
    })(ClientInformation = QMC.ClientInformation || (QMC.ClientInformation = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var ClientInformation;
    (function (ClientInformation) {
        var ClientInformationController = /** @class */ (function () {
            /**
             * Creates an instance of ClientInformationController.
             * @param {ng.ILocationService} $location
             * @param {any} $qui
             * @param {any} $state
             *
             * @memberof ClientInfoController
             */
            function ClientInformationController($location, $qui, $state) {
                var _this = this;
                this.$location = $location;
                this.$qui = $qui;
                this.$state = $state;
                this.newView = true;
                this.selectedClients = [];
                this.$qui.init(this.$qui.getSectionColor("/clientInformation"), function () {
                    _this.$qui.anonAvatar();
                    _this.$qui.bindEvents();
                    _this.$qui.navToggle();
                });
                if (document.getElementById("permissions").getAttribute("clientinformation").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module ClientInformation");
                    this.forbidden = true;
                    return;
                }
                if (this.$state.current.name === "clientInformationById") {
                    this.selectedClients.push(this.$state.params.id);
                }
            }
            ClientInformationController = __decorate([
                QMC.Controller('QMC.ClientInformation', 'ClientInformationController'),
                QMC.Inject('$location', '$qui', '$state')
            ], ClientInformationController);
            return ClientInformationController;
        }());
    })(ClientInformation = QMC.ClientInformation || (QMC.ClientInformation = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/ClientInformation/qmc.client-information.js.map
